import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyPasscodeAndExpirationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyPasscodeAndExpirationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyPasscodeAndExpiration = (
  request: VerifyPasscodeAndExpirationRequest,
  options?: CashRequestOptions
) =>
  post<VerifyPasscodeAndExpirationRequest, VerifyPasscodeAndExpirationResponse>(
    '/2.0/cash/verify-passcode-and-expiration',
    request,
    { ...options, rejectOnError: true }
  )
